import { DEFAULT_CSS_CLASS } from '@constants';
const { feWp } = window;
const { applyFilters } = feWp.hooks;

const blockClass = DEFAULT_CSS_CLASS.VIDEO;
const targetOrigin = '*';
const videoBlocks = document.querySelectorAll(`.${blockClass}`);
const videoPopupBlocks = document.querySelectorAll(`.${blockClass}--thumbnail`);

const handleVideoPlayback = (video) => {
  const videoElm = video.querySelector('video');
  const startTimeMs = parseFloat(videoElm.dataset.previewStart);
  const endTimeMs = parseFloat(videoElm.dataset.previewEnd);

  videoElm.addEventListener('loadedmetadata', () => {
    const videoDurationMs = videoElm.duration * 1000;

    if (startTimeMs === 0 && endTimeMs === 0) {
      videoElm.pause();
      return;
    }

    if (
      startTimeMs >= 0 &&
      endTimeMs > startTimeMs &&
      endTimeMs <= videoDurationMs
    ) {
      videoElm.currentTime = startTimeMs / 1000;

      videoElm.addEventListener('timeupdate', function loop() {
        if (videoElm.currentTime >= endTimeMs / 1000) {
          videoElm.currentTime = startTimeMs / 1000;
        }
      });

      videoElm.play();
    }
  });
};

const handleVideoBlock = (videoBlock) => {
  const playbackBtnPlay = videoBlock.querySelector('.btn-playback--play');
  const videoElementInBlock = videoBlock.querySelector('video');

  // Need at least play button and video element (e.g. HTML5 upload)
  if (!playbackBtnPlay || !videoElementInBlock) return;

  const playbackBtnPause = videoBlock.querySelector('.btn-playback--pause');
  const isAutoplay = videoElementInBlock.autoplay;
  const isMuted = videoElementInBlock.muted;

  const handlePlay = () => {
    playbackBtnPlay.classList.add('hide');
    if (playbackBtnPause) {
      playbackBtnPause.classList.remove('hide');
    }
  };

  const handlePause = () => {
    if (playbackBtnPause) {
      playbackBtnPause.classList.add('hide');
    }
    playbackBtnPlay.classList.remove('hide');
  };

  videoElementInBlock.addEventListener('play', handlePlay);
  videoElementInBlock.addEventListener('pause', handlePause);

  if (isAutoplay && isMuted) {
    handlePlay();
  } else {
    handlePause();
  }

  playbackBtnPlay.addEventListener('click', () => {
    videoElementInBlock.play();
    handlePlay();
  });

  if (playbackBtnPause) {
    playbackBtnPause.addEventListener('click', () => {
      videoElementInBlock.pause();
      handlePause();
    });
  }
};

const processIframes = () => {
  const iframes = document.querySelectorAll(`.${blockClass}--iframe`);
  iframes.forEach((iframe, index) => {
    iframe.id = `embed-${index}`;
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  });
};

const pauseVideo = (element) => {
  const src = element.getAttribute('src');
  let messageData;

  if (src.includes('vimeo')) {
    messageData = JSON.stringify({ method: 'pause', value: true });
  } else if (src.includes('youtube')) {
    messageData = JSON.stringify({ event: 'command', func: 'pauseVideo' });
  } else if (src.includes('wistia')) {
    messageData = JSON.stringify({ method: 'pause', value: true });
  }

  if (messageData) {
    element.contentWindow.postMessage(messageData, targetOrigin); // NOSONAR;
  }
};

const playVideo = (element) => {
  const src = element.getAttribute('src');
  let messageData = null;

  if (src.includes('vimeo')) {
    messageData = JSON.stringify({ method: 'play', value: true });
  } else if (src.includes('youtube')) {
    messageData = JSON.stringify({ event: 'command', func: 'playVideo' });
  } else if (src.includes('wistia')) {
    messageData = JSON.stringify({ method: 'play', value: true });
  }

  if (src.includes('mute')) {
    if (messageData) {
      element.contentWindow.postMessage(messageData, targetOrigin); // NOSONAR;
    }
  } else {
    const domainSrc = src.includes('?') ? src.split('?')[0] : src;
    const updatedSrc = `${domainSrc}?enablejsapi=1&mute=0&autoplay=1&modestbranding=1&rel=0`;
    element.setAttribute('src', updatedSrc);
  }
};

const handlePlayButtonClick = (e) => {
  const parentItem = e.target.closest('div');
  parentItem
    .querySelectorAll('.btn-playback--play, .e-vid__poster-image')
    .forEach((item) => {
      item.classList.add('hide');
    });
  parentItem.querySelectorAll('.btn-playback--pause').forEach((item) => {
    item.classList.remove('hide');
  });
  parentItem.querySelectorAll('iframe').forEach((iframe) => {
    playVideo(iframe);
  });
};

const handlePauseButtonClick = (e) => {
  const parentItem = e.target.closest('div');
  parentItem.querySelectorAll('.btn-playback--play').forEach((item) => {
    item.classList.remove('hide');
  });
  parentItem.querySelectorAll('.btn-playback--pause').forEach((item) => {
    item.classList.add('hide');
  });
  parentItem.querySelectorAll('iframe').forEach((iframe) => {
    pauseVideo(iframe);
  });
};

const videoIframe = () => {
  document.querySelectorAll(`.${blockClass}--iframe`).forEach((element) => {
    element.addEventListener('click', function (e) {
      if (e.target.classList.contains('btn-playback--play')) {
        handlePlayButtonClick(e);
      } else if (e.target.classList.contains('btn-playback--pause')) {
        handlePauseButtonClick(e);
      }
    });
  });
};

const init = applyFilters('b3rg_video_filters', () => {
  document.addEventListener('DOMContentLoaded', () => {
    videoPopupBlocks.forEach(handleVideoPlayback);
    videoBlocks.forEach(handleVideoBlock);
    videoIframe();
    processIframes();
  });
});

if (typeof init === 'function') {
  init();
}
